var _path, _path2, _path3, _path4, _path5, _path6, _mask, _g, _path7, _path8, _path9, _mask2, _g2, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPlaidBoat = function SvgPlaidBoat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 108,
    viewBox: "0 0 164 108",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.7204 71.0265L0 50.0407L55.3792 48.2919L43.7204 71.0265Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7204 71.0265L0 50.0407L55.3792 48.2919L43.7204 71.0265Z",
    fill: "url(#plaid_boat_paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.332 70.4437L106.678 47.7091L163.223 45.3773L125.332 70.4437Z",
    fill: "#C4C4C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.332 70.4437L106.678 47.7091L163.223 45.3773L125.332 70.4437Z",
    fill: "url(#plaid_boat_paint1_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7887 0.0632324L22.928 68.414L81.7887 88.5304V0.0632324Z",
    fill: "url(#plaid_boat_paint2_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 69.414L80.6607 1.06323V89.5304L22 69.414ZM81.59 1.2738L81.3639 90.4673L91.3323 96.4298L132.137 73.4653L81.59 1.2738Z",
    fill: "#A51C35"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 1,
    width: 111,
    height: 96
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 69.414L80.6607 1.06323V89.5304L22 69.414ZM81.59 1.2738L81.3639 90.4673L91.3323 96.4298L132.137 73.4653L81.59 1.2738Z",
    fill: "#A51C35"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 0.0632324,
    width: 12,
    height: 76,
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 17.0632,
    width: 12,
    height: 168,
    transform: "rotate(90 175 17.0632)",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 35.0632,
    width: 12,
    height: 168,
    transform: "rotate(90 175 35.0632)",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 0.0632324,
    width: 12,
    height: 76,
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: -2.93677,
    width: 12,
    height: 76,
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: -2.93677,
    width: 12,
    height: 76,
    fill: "black",
    fillOpacity: 0.6
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2504 98.2393L0.777222 50.9728L77.1331 61.9086L164 46.3093L146.715 93.9288L80.2119 107.476L19.2504 98.2393Z",
    fill: "url(#plaid_boat_paint3_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2504 98.2393L0.777222 50.9728L77.1331 61.9086L164 46.3093L146.715 93.9288L80.2119 107.476L19.2504 98.2393Z",
    fill: "url(#plaid_boat_paint4_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4732 97.4614L0 50.1949L76.3558 61.1308L163.223 45.5314L145.938 93.1509L79.4347 106.698L18.4732 97.4614Z",
    fill: "#A51C35"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 46,
    width: 164,
    height: 62
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4732 97.9932L0 50.7267L76.3558 61.6626L163.223 46.0632L145.938 93.6828L79.4347 107.23L18.4732 97.9932Z",
    fill: "#A51C35"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 33.0632,
    width: 12,
    height: 76,
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 33.0632,
    width: 12,
    height: 76,
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 50.0632,
    width: 12,
    height: 168,
    transform: "rotate(90 169 50.0632)",
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 68.0632,
    width: 12,
    height: 168,
    transform: "rotate(90 169 68.0632)",
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 33.0632,
    width: 12,
    height: 76,
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 33.0632,
    width: 12,
    height: 76,
    fill: "black",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "plaid_boat_paint0_linear",
    x1: 27.6896,
    y1: 48.2919,
    x2: 27.6896,
    y2: 71.0265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D789F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plaid_boat_paint1_linear",
    x1: 134.95,
    y1: 45.3773,
    x2: 134.95,
    y2: 70.4437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D789F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plaid_boat_paint2_linear",
    x1: 69.3675,
    y1: -25.5853,
    x2: 70.5333,
    y2: 161.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC8387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557327,
    stopColor: "#CF425C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plaid_boat_paint3_linear",
    x1: 82.3863,
    y1: 10.3221,
    x2: 82.3863,
    y2: 91.5426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC8387"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plaid_boat_paint4_linear",
    x1: 82.3863,
    y1: 25.4781,
    x2: 82.3863,
    y2: 135.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC8387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF425C"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlaidBoat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plaid_boat.81f6dc84.svg";
export { ForwardRef as ReactComponent };